module.exports = __webpack_public_path__ + "media/components/Bazaarvoice/icons/check-shield-df12149a08a3cc1767fd27836f871f4b.svg";